// eslint-disable-next-line import/no-unresolved
import VideoPlayer from '@components/M06-video-player/video-player';
import type { IVideoPlaceholderImageProps } from '@components/video-placeholder-image/video-placeholder-image';
// eslint-disable-next-line import/no-unresolved
import VideoPlaceholderImage from '@components/video-placeholder-image/video-placeholder-image';
import { useCookieConsent } from '@hooks/cookieConsent.ts/useCookieConsent';
import React, { useState } from 'react';

export interface IHomeHeroVideoProps {
    twentyThreeVideoPlayerCode: string;
    guid: string;
    placeholder: IVideoPlaceholderImageProps;
    placeholderMobile: IVideoPlaceholderImageProps;
    videoFunctionCookieRequirementText?: string;
    videoFunctionCookieRequirementButtonText?: string;
    videoCookiePlaceholderIconUrl?: string;
}

export default function HomeHeroVideo({
    twentyThreeVideoPlayerCode,
    guid,
    placeholder,
    placeholderMobile,
    videoFunctionCookieRequirementText,
    videoFunctionCookieRequirementButtonText,
    videoCookiePlaceholderIconUrl,
}: IHomeHeroVideoProps) {
    const cookieConsent = useCookieConsent();
    const isMobile = matchMedia('(max-width: 1024px)').matches;
    const [isPlaying, setIsPlaying] = useState(false);
    const placeholderSrc = isMobile ? placeholderMobile.src : placeholder.src;
    const placeholderAlt = isMobile ? placeholderMobile.alt : placeholder.alt;

    const handleStartVideo = () => {
        if (!cookieConsent) {
            CookieConsent.renew();
            return;
        }

        setIsPlaying(true);
    };

    return (
        <section className="fa-home-hero-video__media-container">
            <div className="fa-video-player__container">
                {placeholderSrc && !isPlaying && (
                    <button
                        className="fa-home-hero-video__image-placeholder-button"
                        aria-haspopup="true"
                        aria-label={`Play video: ${placeholderAlt}`}
                        tabIndex={isPlaying ? -1 : 0}
                        onClick={handleStartVideo}
                    >
                        <VideoPlaceholderImage alt={placeholderAlt} src={placeholderSrc} />
                    </button>
                )}

                {isPlaying && (
                    <div aria-live="assertive">
                        <VideoPlayer
                            videoIsPlaying={true}
                            hideCookiePlaceholder={placeholderSrc ? true : false}
                            guid={guid}
                            twentyThreeVideoPlayerCode={twentyThreeVideoPlayerCode}
                            videoFunctionCookieRequirementText={videoFunctionCookieRequirementText}
                            videoFunctionCookieRequirementButtonText={videoFunctionCookieRequirementButtonText}
                            videoCookiePlaceholderIconUrl={videoCookiePlaceholderIconUrl}
                            size="Medium"
                            onCloseCallback={() => setIsPlaying(false)}
                        />
                    </div>
                )}
            </div>
        </section>
    );
}
